const env = process.env.NODE_ENV;

const constants = {
  isProduction: env === 'production',
  onlineTicketDomain: env === 'production' ? 'https://online-ticket-samsung-api.lemondice.com' : 'http://localhost:4001',
  localeMessage: {
    UNKNOWN_ERROR: {
      en: 'An unknown error occurred.',
      zhTW: '發生未知錯誤。',
    },
    SYSTEM_BUSY: {
      en: 'System busy, please try again later.',
      zhTW: '系統繁忙，請稍候再試。',
    },
    LAST_CALLED_NUMBER: {
      en: 'Last Called Number',
      zhTW: '現時叫號',
    },
    YOUR_NUMBER: {
      en: 'Your Number',
      zhTW: '你的輪候號碼',
    },
    TICKET_PASSED: {
      en: 'The ticket has been passed',
      zhTW: '票號已過'
    },
    WRONG_PHONE_NO: {
      en: 'Please input the correct phone number.',
      zhTW: '請輸入正確電話號碼。',
    },
    WRONG_VERIFICATION_CODE: {
      en: 'Please input the verification code.',
      zhTW: '請輸入驗證碼',
    },
    CLICK_TO_AGREE_TEL_NO_USAGE: {
      en: 'Please check below for agreeing to provide the mobile number for using the Online Queuing system',
      zhTW: '請在下方點擊表示同意提供電話號碼僅作取票系統使用',
    },
    TICKET_INVALID: {
      en: 'Ticket is no longer valid, re-queuing is required.',
      zhTW: '你的籌號已失效，請重新取票。',
    },
    TICKET_PROCESSED: {
      en: 'Ticket was completed, re-queuing is required.',
      zhTW: '你的籌號已完成，請重新取票。',
    },
    ONLINE_QUEUING: {
      en: 'Online Queuing',
      zhTW: '網上取票',
    },
    HOME_PAGE_HEADER_1: {
      en: 'Samsung Customer Service Center',
      zhTW: '三星客戶服務中心',
    },
    HOME_PAGE_HEADER_2: {
      en: 'is now providing online queuing and Pre-booking',
      zhTW: '現正提供網上取票 及 預約服務，',
    },
    HOME_PAGE_HEADER_3: {
      en: 'service to serve you with enhanced convenience.',
      zhTW: '以有效為你提供便捷的服務。',
    },
    QUEUE: {
      en: 'Queue',
      zhTW: '取票',
    },
    QUEUE_SENTENCE: {
      en: 'Get a ticket remotely before your visit and track the real-time waiting status to save your time. Ticket is only valid on the same day.',
      zhTW: '可於前往客戶服務中心前預先取票並瀏覽實時的叫號狀況，節省輪侯時間。票號僅於當天有效。',
    },
    PRE_BOOK: {
      en: 'Pre-book',
      zhTW: '預約',
    },
    PRE_BOOK_SENTENCE: {
      en: 'Book an appointment in advance to enjoy priority service.',
      zhTW: '可預約客戶服務中心未來的服務時間，客戶服務中心會優先處理有預約之客戶。',
    },
    OPERATING_HOURS: {
      en: 'Operating hours',
      zhTW: '營業時間',
    },
    LOCATION_REMARK: {
      en: 'Due to ongoing system upgrade, online queuing service is temporarily unavailable. You may make a reservation or visit the service center directly to queue for service.',
      zhTW: '由於進行系統升級，暫時無法提供線上取票服務，你可預約或直接前往服務中心取票輪候。',
    },
    REMARK_1: {
      en: 'The Online Queuing system would cease providing service shortly before the end of the service center\'s operation hours.',
      zhTW: '網上取票服務會於客戶服務中心營業時間即將結束前停止。',
    },
    REMARK_2: {
      en: 'Please note the latest announcement for the special operation hours.',
      zhTW: '特別營業時間請留意客戶服務中心公告。',
    },
    NO_OF_TICKET_WAITING: {
      en: 'Number of Tickets Waiting in Queue',
      zhTW: '現時輪候總票數',
    },
    SELECT_SERVICE_TYPE: {
      en: 'Please select service type',
      zhTW: '請選擇服務類型',
    },
    NOW_SERVING: {
      en: 'Now Serving',
      zhTW: '正在處理票號',
    },
    NEXT_TICKET_NUMBER: {
      en: 'Next Ticket Number',
      zhTW: '即將派發票號',
    },
    EST_WAITING_TIME: {
      en: 'Estimated Waiting Time',
      zhTW: '預計等候時間',
    },
    MINS: {
      en: 'mins',
      zhTW: '分鐘',
    },
    SELECT: {
      en: 'Select',
      zhTW: '選擇',
    },
    BACK: {
      en: 'Back',
      zhTW: '返回',
    },
    NEXT: {
      en: 'Next',
      zhTW: '下一步',
    },
    SMS_VERIFICATION: {
      en: 'SMS verification',
      zhTW: '短訊驗證',
    },
    MOBILE_NUMBER: {
      en: 'Mobile number',
      zhTW: '電話號碼',
    },
    VERIFY: {
      en: 'Verify',
      zhTW: '獲取驗證',
    },
    SENT: {
      en: 'Sent',
      zhTW: '已發送',
    },
    RETRIEVE_AFTER: {
      en: 'Retrieve after',
      zhTW: '後可重新獲取',
    },
    SECONDS: {
      en: 'seconds',
      zhTW: '秒',
    },
    VERIFICATION_CODE: {
      en: 'Verification code',
      zhTW: '驗證碼',
    },
    CONFIRM: {
      en: 'Confirm',
      zhTW: '確認',
    },
    SMS_OPTIONS_1: {
      en: 'I agree to provide the mobile number for using the Online Queuing system. I understand the mobile number would not be used for other purposes and will be erased by midnight on the same day.',
      zhTW: '本人同意提供電話號碼僅作取票系統使用，有關的電話號碼將不會作其他用途，並記錄將於翌日0時0分清除',
    },
    SMS_OPTIONS_2: {
      en: 'I wish to receive SMS reminder (optional)',
      zhTW: '本人希望接收短訊提示（可選填）',
    },
    SMS_OPTIONS_2_SUB: {
      en: '(If the ticket will be served within 5mins, SMS reminder will not be sent out.)',
      zhTW: '(如櫃位將會在五分鐘內處理即將派發的票號，短訊提示會自動設定為不收取。)',
    },
    SMS_REMARKS_1: {
      en: 'Customers should present the ticket record at the arrival at the service center.',
      zhTW: '客戶到達指維修中心後，須出示有關網上取票的記錄以作識別及驗證之用。',
    },
    SMS_REMARKS_2: {
      en: 'If customers cannot present the record, service center reserves the right to cancel the ticket.',
      zhTW: '如客戶未能出示有關記錄，本中心保留權利取消已確認的票號。',
    },
    SMS_REMARKS_3: {
      en: 'Tickets that are already called upon will be invalid after 30 minutes; re-queuing is required thereafter.',
      zhTW: '票號於叫號後將保留30分鐘有效，超過有效時間仍未使用服務的客戶需重新取票。',
    },
    YOUR_TICKET_NUMBER: {
      en: 'Your Ticket Number',
      zhTW: '你的票號',
    },
    TICKET_ISSUE_TIME: {
      en: 'Ticket issue time',
      zhTW: '取票時間',
    },
    TICKET_CALL_TIME: {
      en: 'Ticket call time',
      zhTW: '叫號時間',
    },
    STATUS_LAST_UPDATED: {
      en: 'Status last updated',
      zhTW: '最近更新時間',
    },
    CANCEL: {
      en: 'Cancel',
      zhTW: '刪除',
    },
    CANCEL_TICKET_Q: {
      en: 'Confirm to cancel the ticket?',
      zhTW: '確認刪除票號？',
    },
    TICKET_CANCEL_CONFIRMED_1: {
      en: 'You have confirmed to cancel the ticket.',
      zhTW: '您已確認刪除您的票號。',
    },
    TICKET_CANCEL_CONFIRMED_2: {
      en: 'If you need to use the service, please get a new ticket.',
      zhTW: '若需使用服務請重新取票輪候。',
    },
    GET_NEW_TICKET: {
      en: 'Get a new ticket',
      zhTW: '重新取票',
    },
    TICKET_PROCESSED_CONTACT_CS: {
      en: 'Ticket has been processed. Please contact our center CS if it has not been completed.',
      zhTW: '你的籌號已完成，如未完成請聯絡中心客服協助。',
    },
    REMINDER_1: {
      en: 'For customer who has Pre-booked online, please get ticket at Service Center directly (G Online Appointment)',
      zhTW: '已於線上預約之客人請直接前往維修中心提取票號 (G 網上預約)',
    },
    TICKET_PAUSED: {
      en: 'Sorry, the number of ticket for this Service Center has been distributed',
      zhTW: '抱歉，此服務中心之籌號已停止派發',
    },
    REMINDER_2: {
      en: 'Ticket will be invalid after 30 minutes from the call; re-queuing is required thereafter',
      zhTW: '票號於叫號起計30分鐘後失效，若您錯過輪候票號，將需重新取票輪候',
    },
    SHOW_QR_CODE_REQUEUE: {
      en: 'Please show this QR code to the kiosk.',
      zhTW: '請於自助籌號機前展示此二維碼',
    },
    CLOSE: {
      en: 'Close',
      zhTW: '關閉',
    },
    SHOW_QR_CODE: {
      en: 'Click here for re-queue',
      zhTW: '如需補飛請按這裡',
    },
    OK:{
      en: ' OK',
      zhTW: '確定',
    },
  },
  emptyFnc: () => {
  },
};

export default constants;